import { apiClient } from "../config";

async function addExistingMembersToCommunity(data: any) {
  const res = await apiClient.post(`/admin/communities/members`, data);
  return res.data;
}

export default addExistingMembersToCommunity;
